var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13709_12454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 12.4998C3.39006 12.4998 3.00177 12.4998 2.69549 12.373C2.28711 12.2038 1.96265 11.8794 1.79349 11.471C1.66663 11.1647 1.66663 10.7764 1.66663 9.99984V4.33317C1.66663 3.39975 1.66663 2.93304 1.84828 2.57652C2.00807 2.26292 2.26304 2.00795 2.57664 1.84816C2.93316 1.6665 3.39987 1.6665 4.33329 1.6665H9.99996C10.7765 1.6665 11.1648 1.6665 11.4711 1.79337C11.8795 1.96253 12.2039 2.28698 12.3731 2.69536C12.5 3.00165 12.5 3.38993 12.5 4.1665M10.1666 18.3332H15.6666C16.6 18.3332 17.0668 18.3332 17.4233 18.1515C17.7369 17.9917 17.9918 17.7368 18.1516 17.4232C18.3333 17.0666 18.3333 16.5999 18.3333 15.6665V10.1665C18.3333 9.23308 18.3333 8.76637 18.1516 8.40985C17.9918 8.09625 17.7369 7.84128 17.4233 7.68149C17.0668 7.49984 16.6 7.49984 15.6666 7.49984H10.1666C9.23321 7.49984 8.7665 7.49984 8.40998 7.68149C8.09637 7.84128 7.8414 8.09625 7.68162 8.40985C7.49996 8.76637 7.49996 9.23308 7.49996 10.1665V15.6665C7.49996 16.5999 7.49996 17.0666 7.68162 17.4232C7.8414 17.7368 8.09637 17.9917 8.40998 18.1515C8.7665 18.3332 9.23321 18.3332 10.1666 18.3332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13709_12454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.879dbda46616d6f7cb078cd43e2e7d0a.svg";
export { ForwardRef as ReactComponent };